'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBlAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28.0481 0H0.0480652V20H28.0481V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.3814 6.66667H18.7147V12.655C18.7147 13.3978 18.2673 14.3835 17.7021 14.8679L15.5761 16.6903C14.7322 17.4136 13.3595 17.4098 12.52 16.6903L10.394 14.8679C9.83475 14.3886 9.3814 13.3999 9.3814 12.655V6.66667Z",
          fill: "#216CD3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3814 9.33331C11.0132 9.33331 10.7147 9.03484 10.7147 8.66665C10.7147 8.29846 11.0132 7.99998 11.3814 7.99998C11.7496 7.99998 12.0481 8.29846 12.0481 8.66665C12.0481 9.03484 11.7496 9.33331 11.3814 9.33331ZM14.0481 9.33331C13.6799 9.33331 13.3814 9.03484 13.3814 8.66665C13.3814 8.29846 13.6799 7.99998 14.0481 7.99998C14.4162 7.99998 14.7147 8.29846 14.7147 8.66665C14.7147 9.03484 14.4162 9.33331 14.0481 9.33331ZM16.7147 9.33331C16.3465 9.33331 16.0481 9.03484 16.0481 8.66665C16.0481 8.29846 16.3465 7.99998 16.7147 7.99998C17.0829 7.99998 17.3814 8.29846 17.3814 8.66665C17.3814 9.03484 17.0829 9.33331 16.7147 9.33331Z",
          fill: "#F7E14B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0481 15.3333C11.6799 15.3333 11.3814 15.0348 11.3814 14.6666C11.3814 14.2985 11.6799 14 12.0481 14C12.4162 14 12.7147 14.2985 12.7147 14.6666C12.7147 15.0348 12.4162 15.3333 12.0481 15.3333ZM14.0481 16C13.6799 16 13.3814 15.7015 13.3814 15.3333C13.3814 14.9651 13.6799 14.6666 14.0481 14.6666C14.4162 14.6666 14.7147 14.9651 14.7147 15.3333C14.7147 15.7015 14.4162 16 14.0481 16ZM16.0481 15.3333C15.6799 15.3333 15.3814 15.0348 15.3814 14.6666C15.3814 14.2985 15.6799 14 16.0481 14C16.4162 14 16.7147 14.2985 16.7147 14.6666C16.7147 15.0348 16.4162 15.3333 16.0481 15.3333Z",
          fill: "#F7E14B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.7147 10.6666H9.38139V13.3333H18.7147V10.6666Z",
          fill: "#E12539"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.0481 13.3333C14.7844 13.3333 15.3814 12.7364 15.3814 12C15.3814 11.2636 14.7844 10.6666 14.0481 10.6666C13.3117 10.6666 12.7147 11.2636 12.7147 12C12.7147 12.7364 13.3117 13.3333 14.0481 13.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.71473 4.66667C8.71473 4.66667 11.3814 4 14.0481 4C16.7147 4 19.3814 4.66667 19.3814 4.66667L18.7147 7.33333C18.7147 7.33333 16.3814 6.66667 14.0481 6.66667C11.7147 6.66667 9.3814 7.33333 9.3814 7.33333L8.71473 4.66667Z",
          fill: "#F7E14B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0481 6C13.6799 6 13.3814 5.70152 13.3814 5.33333C13.3814 4.96514 13.6799 4.66667 14.0481 4.66667C14.4163 4.66667 14.7147 4.96514 14.7147 5.33333C14.7147 5.70152 14.4163 6 14.0481 6ZM16.7147 6C16.3465 6 16.0481 5.70152 16.0481 5.33333C16.0481 4.96514 16.3465 4.66667 16.7147 4.66667C17.0829 4.66667 17.3814 4.96514 17.3814 5.33333C17.3814 5.70152 17.0829 6 16.7147 6ZM11.3814 6C11.0132 6 10.7147 5.70152 10.7147 5.33333C10.7147 4.96514 11.0132 4.66667 11.3814 4.66667C11.7496 4.66667 12.0481 4.96514 12.0481 5.33333C12.0481 5.70152 11.7496 6 11.3814 6Z",
          fill: "#5E5216"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.0480652 0V20H28.0481V0H0.0480652ZM27.5481 0.5H0.548065L0.548065 19.5H27.5481V0.5Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagBlAsset = forwardRef(FlagBlAsset);

export { VpFlagBlAsset as default };
